package com.jingfangpai.api.clients

import com.jingfangpai.common.data.response.ApiResponse
import kotlinx.serialization.Serializable
import kotlinx.serialization.decodeFromString
import com.jingfangpai.common.coroutines.applicationDispatcher
import kotlinx.coroutines.launch
import io.ktor.http.*
import io.ktor.client.plugins.*
import io.ktor.client.request.*
import com.jingfangpai.common.json.json
import kotlin.js.JsName
import io.ktor.content.TextContent
import io.ktor.client.call.body
import com.jingfangpai.api.base.BaseServiceClient
import com.jingfangpai.common.orm.mapping.enums.CommentType
import kotlin.String
import com.jingfangpai.common.orm.mapping.enums.CommentEntityType
import com.jingfangpai.common.orm.mapping.Comment

object CommentApiClient :BaseServiceClient() {

	@JsName("fetchBookComments")
	fun fetchBookComments(type:com.jingfangpai.common.orm.mapping.enums.CommentType,bookId:kotlin.String,authorId:kotlin.String, okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<kotlin.Array<com.jingfangpai.common.orm.mapping.Comment>>) -> Unit, errorCallback: (exception:Throwable) -> Unit){
		launch(applicationDispatcher) {
			val params = listOf<Pair<String,String>>(
			"type" to "${type?:""}",
			"bookId" to "${bookId?:""}",
			"authorId" to "${authorId?:""}",
			).formUrlEncode()
			try {
				val result:com.jingfangpai.common.data.response.ApiResponse<kotlin.Array<com.jingfangpai.common.orm.mapping.Comment>> = httpClient.get {
				    url("/api/comment/fetchBookComments?$params")
				}.body()
				okCallback(result)
			}catch (e:Throwable){
				errorCallback(e)
			}
		}
	}


	@JsName("getCommentById")
	fun getCommentById(id:kotlin.String, okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<com.jingfangpai.common.orm.mapping.Comment>) -> Unit, errorCallback: (exception:Throwable) -> Unit){
		launch(applicationDispatcher) {
			val params = listOf<Pair<String,String>>(
			"id" to "${id?:""}",
			).formUrlEncode()
			try {
				val result:com.jingfangpai.common.data.response.ApiResponse<com.jingfangpai.common.orm.mapping.Comment> = httpClient.get {
				    url("/api/comment/getById?$params")
				}.body()
				okCallback(result)
			}catch (e:Throwable){
				errorCallback(e)
			}
		}
	}


	@JsName("getComments")
	fun getComments(entityType:com.jingfangpai.common.orm.mapping.enums.CommentEntityType,entityId:kotlin.String,type:com.jingfangpai.common.orm.mapping.enums.CommentType, okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<kotlin.Array<com.jingfangpai.common.orm.mapping.Comment>>) -> Unit, errorCallback: (exception:Throwable) -> Unit){
		launch(applicationDispatcher) {
			val params = listOf<Pair<String,String>>(
			"entityType" to "${entityType?:""}",
			"entityId" to "${entityId?:""}",
			"type" to "${type?:""}",
			).formUrlEncode()
			try {
				val result:com.jingfangpai.common.data.response.ApiResponse<kotlin.Array<com.jingfangpai.common.orm.mapping.Comment>> = httpClient.get {
				    url("/api/comment/getComments?$params")
				}.body()
				okCallback(result)
			}catch (e:Throwable){
				errorCallback(e)
			}
		}
	}


	@JsName("save")
	fun save(comment:com.jingfangpai.common.orm.mapping.Comment, okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<com.jingfangpai.common.orm.mapping.Comment>) -> Unit, errorCallback: (exception:Throwable) -> Unit){
		launch(applicationDispatcher) {
			val params = listOf<Pair<String,String>>(
			).formUrlEncode()
			try {
				val result:com.jingfangpai.common.data.response.ApiResponse<com.jingfangpai.common.orm.mapping.Comment> = httpClient.post {
				    url("/api/comment/save?$params")
				    setBody(TextContent(json.encodeToString(com.jingfangpai.common.orm.mapping.Comment.serializer(),comment), io.ktor.http.ContentType.Application.Json))
				}.body()
				okCallback(result)
			}catch (e:Throwable){
				errorCallback(e)
			}
		}
	}

}
